import React, { useRef, useEffect, useState } from "react";
import { BrowserMultiFormatReader } from "@zxing/library";
import Layout from "../components/layout";
import toast from "react-hot-toast";
import "../index.css";
import { useNavigate } from "react-router-dom";

const ScanEntry = () => {
  const [scanResult, setScanResult] = useState(null);
  const videoRef = useRef(null);
  const navigate = useNavigate();
  const codeReader = new BrowserMultiFormatReader();

  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const startScanner = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: "environment" },
        });
        videoRef.current.srcObject = stream;

        codeReader.decodeFromVideoDevice(
          null,
          videoRef.current,
          (result, error) => {
            if (result) {
              setScanResult(result.text);
              handleScan(result.text);
            }
            if (error && !hasError) {
              console.error("QR Code Scan Error:", error);
              setHasError(true); // Prevent further logging
            }
          }
        );
      } catch (err) {
        console.error(err);
      }
    };

    startScanner();

    return () => {
      codeReader.reset();
    };
  }, [navigate, hasError]);

  const handleScan = async (result) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/auth/member-entry-scanned`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
          method: "POST",
          body: JSON.stringify({ matricule: result }),
        }
      );

      const parseRes = await response.json();

      if (parseRes.success) {
        toast.success("Patient identifié");
        navigate(`/member-entry-detail/${encodeURIComponent(result)}`);
      } else {
        toast.error("Member not recognized for entry");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <Layout>
      <div className="App px-5 mt-3">
        <div className="d-flex justify-content-center">
          <h3 className="page-title">QR Scanner Entrée</h3>
        </div>
        <div className="d-flex justify-content-center mt-10">
          {scanResult ? (
            <div>
              numéro de matricule identifié: <p>{scanResult}</p>
            </div>
          ) : (
            <video
              ref={videoRef}
              style={{
                width: "100%",
                maxWidth: "500px",
                border: "2px solid #000",
              }}
              autoPlay
            />
          )}
        </div>
      </div>
    </Layout>
  );
};

export default ScanEntry;
